export const lotLayerDefinition = {
    geometryType: 'esriGeometryPolygon',
    objectIdField: 'uniqueId',
    extent: {
        xmin: 112.125077691,
        ymin: -35.02303714499999,
        xmax: 123.63228824299995,
        ymax: -17.30794632300001,
        spatialReference: {
            wkid: 7844,
            latestWkid: 7844
        }
    },
    fields: [
        {
            name: 'objectid',
            type: 'esriFieldTypeOID',
            alias: 'objectid',
            editable: false,
            nullable: false
        },
        {
            name: 'guid',
            type: 'esriFieldTypeString',
            alias: 'guid',
            editable: true,
            nullable: false,
            length: 50
        },
        {
            name: 'id',
            type: 'esriFieldTypeInteger',
            alias: 'id',
            editable: true,
            nullable: false
        },
        {
            name: 'type',
            type: 'esriFieldTypeInteger',
            alias: 'type',
            editable: true,
            nullable: true
        },
        {
            name: 'name',
            type: 'esriFieldTypeString',
            alias: 'name',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'totalarea',
            type: 'esriFieldTypeDouble',
            alias: 'totalarea',
            editable: true,
            nullable: true
        },
        {
            name: 'polygonids',
            type: 'esriFieldTypeString',
            alias: 'polygonids',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'purpose',
            type: 'esriFieldTypeString',
            alias: 'purpose',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'comment',
            type: 'esriFieldTypeString',
            alias: 'comment',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'acquisitiontransferaction',
            type: 'esriFieldTypeString',
            alias: 'acquisitiontransferaction',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'statutoryreference',
            type: 'esriFieldTypeString',
            alias: 'statutoryreference',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'roadname',
            type: 'esriFieldTypeString',
            alias: 'roadname',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'roadtype',
            type: 'esriFieldTypeString',
            alias: 'roadtype',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'roadsuffix',
            type: 'esriFieldTypeString',
            alias: 'roadsuffix',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'roadid',
            type: 'esriFieldTypeInteger',
            alias: 'roadid',
            editable: true,
            nullable: true
        }
    ]
};
